import { render, staticRenderFns } from "./ManageUsers.vue?vue&type=template&id=1953b432"
import script from "./ManageUsers.vue?vue&type=script&lang=ts"
export * from "./ManageUsers.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports